import { participantStatuses } from '../../../../../backend/extraTypes';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
import { shiftParticipantHoursHistoryStatus } from './shiftParticipantHoursHistoryTypes';
export const shiftParticipantSchema = z.object({
    missionId: z.string().uuid(),
    shiftId: z.string().uuid(),
    participantFullName: z.string().trim().min(1),
    participantId: z.string().uuid(),
    participantEmail: z.string().trim().min(1),
    participantContactEmail: z.string().optional(),
    positionId: z.string().uuid(),
    positionName: z.string().trim().min(1),
    countyTribe: z.string().trim().min(1),
    occupationsWithEcls: z.string().trim().min(1).array(),
    participantContactInfo: z.string().optional(),
    status: z.enum(participantStatuses).optional(),
    showContactInfo: z.boolean().optional(),
    addedByAdmin: z.boolean().optional(),
    internalStatusChange: z.boolean().optional(),
    hours: z.number().optional(),
    hoursFrom: z.number().optional(),
    hoursTo: z.number().optional(),
    hoursStatus: z.enum(shiftParticipantHoursHistoryStatus).optional(),
    deleted: z.boolean().optional(),
});
export const shiftParticipantEntityName = 'shiftParticipant';
export const shiftParticipantColumns = defineColumns({
    search: {
        type: 'full-text-search-required',
        language: 'english',
    },
    participantId: {
        type: 'id-required',
        index: true,
    },
    shiftId: {
        type: 'id-required',
        index: true,
    },
    shiftStartTime: {
        type: 'number-required',
    },
    shiftStopTime: {
        type: 'number-required',
    },
    missionId: {
        type: 'id-required',
        index: true,
    },
    missionName: {
        type: 'string-required',
    },
    status: {
        type: 'string-required',
        index: true,
    },
    participantFullName: {
        type: 'string-required',
    },
    participantEmail: {
        type: 'string-required',
        index: true,
    },
    participantContactEmail: {
        type: 'string',
        index: true,
    },
    participantContactInfo: {
        type: 'string',
        index: true,
    },
    occupations: {
        type: 'string-array-required',
    },
    countyTribe: {
        type: 'string-required',
    },
    positionId: {
        type: 'string-required',
        index: true,
    },
    positionName: {
        type: 'string-required',
    },
    hours: {
        type: 'number',
    },
    hoursFrom: {
        type: 'number',
    },
    hoursTo: {
        type: 'number',
    },
    hoursStatus: {
        type: 'string-required',
    },
    missionType: {
        type: 'string-required',
    },
    missionTypeId: {
        type: 'string-required',
    },
    organizationSharing: {
        type: 'string-array-required',
    },
    shiftLocation: {
        type: 'string-required',
    },
    showContactInfo: {
        type: 'boolean',
    },
    addedByAdmin: {
        type: 'boolean-required',
    },
    deleted: {
        type: 'boolean',
    },
});
